<template>
  <div class="cloud-drive-invite">
    <div class="invite-container">
      <div v-if="loading" class="loading">加载中...</div>

      <div v-else-if="inviteInfo" class="invite-card">
        <h2>{{ inviteInfo.space_name }}</h2>
        <p class="description">{{ inviteInfo.space_description }}</p>

        <div class="info-item" v-if="inviteInfo.expire_at">
          <span class="label">有效期至：</span>
          <span>{{ inviteInfo.expire_at }}</span>
        </div>

        <div class="info-item">
          <span class="label">审批要求：</span>
          <span>{{ inviteInfo.need_approval ? '需要审批' : '无需审批' }}</span>
        </div>

        <button
          @click="handleJoin"
          :disabled="joining"
          class="btn-primary"
        >
          {{ joining ? '加入中...' : (isLoggedIn ? '加入共享云盘' : '登录并加入') }}
        </button>
      </div>

      <div v-else-if="error" class="error-card">
        <p>{{ error }}</p>
        <button @click="$router.push('/')" class="btn-secondary">返回首页</button>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchInviteInfo, joinShare } from '@/api/cloudDrive'
import { isAuthenticated } from '@/store/session'

export default {
  name: 'CloudDriveInvite',
  data() {
    return {
      loading: true,
      joining: false,
      inviteInfo: null,
      error: null
    }
  },
  computed: {
    isLoggedIn() {
      return isAuthenticated()
    }
  },
  async mounted() {
    await this.loadInviteInfo()

    // 检查是否是从登录页返回的（通过 query 参数 auto_join）
    if (this.isLoggedIn && this.$route.query.auto_join === '1') {
      // 移除 auto_join 参数
      const query = { ...this.$route.query }
      delete query.auto_join
      this.$router.replace({ path: this.$route.path, query })

      // 自动执行加入
      await this.handleJoin()
    }
  },
  methods: {
    async loadInviteInfo() {
      try {
        this.loading = true
        const inviteCode = this.$route.query.invite_code
        const qrToken = this.$route.query.qr_token

        if (!inviteCode && !qrToken) {
          this.error = '缺少邀请码或二维码参数'
          return
        }

        this.inviteInfo = await fetchInviteInfo({ inviteCode, qrToken })
      } catch (err) {
        this.error = err.message || '获取邀请信息失败'
      } finally {
        this.loading = false
      }
    },

    async handleJoin() {
      // 如果未登录，先跳转到登录页
      if (!this.isLoggedIn) {
        // 构建带 auto_join 标记的 redirect URL
        const currentQuery = { ...this.$route.query, auto_join: '1' }
        const queryString = Object.keys(currentQuery)
          .map(key => `${key}=${encodeURIComponent(currentQuery[key])}`)
          .join('&')
        const redirectUrl = `${this.$route.path}?${queryString}`

        this.$router.push({
          name: 'login',
          query: { redirect: redirectUrl }
        })
        return
      }

      try {
        this.joining = true
        const inviteCode = this.$route.query.invite_code
        const qrToken = this.$route.query.qr_token

        const result = await joinShare({ inviteCode, qrToken })

        if (result.code === 200) {
          this.$router.push({
            name: 'cloud-drive-files',
            params: { spaceId: result.data.share_space_id }
          })
        } else {
          alert(result.msg || '加入失败')
        }
      } catch (err) {
        alert(err.message || '加入失败')
      } finally {
        this.joining = false
      }
    }
  }
}
</script>

<style scoped>
.cloud-drive-invite {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 20px;
}

.invite-container {
  width: 100%;
  max-width: 500px;
}

.invite-card,
.error-card {
  background: white;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.invite-card h2 {
  margin: 0 0 16px;
  font-size: 24px;
  color: #333;
}

.description {
  color: #666;
  margin-bottom: 24px;
  line-height: 1.6;
}

.info-item {
  margin-bottom: 12px;
  font-size: 14px;
}

.info-item .label {
  color: #999;
  margin-right: 8px;
}

.btn-primary,
.btn-secondary {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 24px;
}

.btn-primary {
  background: #1890ff;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #40a9ff;
}

.btn-primary:disabled {
  background: #d9d9d9;
  cursor: not-allowed;
}

.btn-secondary {
  background: #f0f0f0;
  color: #333;
}

.btn-secondary:hover {
  background: #e0e0e0;
}

.loading,
.error-card {
  text-align: center;
  color: #666;
}
</style>
